import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { putCertTemplate } from "../../store/certificates/actions";
export var useApiUpdateCertificate = function (trigger, id, certificateBody) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        loadingPutCertificate: state.Certificates.loadingPutCertificate,
        responsePutCertificate: state.Certificates.responsePutCertificate,
        errorPutCertificate: state.Certificates.errorPutCertificate,
    }); }), loadingPutCertificate = _a.loadingPutCertificate, responsePutCertificate = _a.responsePutCertificate, errorPutCertificate = _a.errorPutCertificate;
    useEffect(function () {
        if (trigger) {
            dispatch(putCertTemplate(certificateBody, id));
        }
    }, [trigger]);
    return {
        loadingPutCertificate: loadingPutCertificate,
        responsePutCertificate: responsePutCertificate,
        errorPutCertificate: errorPutCertificate,
    };
};
